<template>
  <div class="loading-container">
    <div class="mask"></div>
    <div class="loader">
      <div class="lds-css ng-scope">
        <div class="lds-rolling">
          <div></div>
        </div>
      </div>
      <div v-if="!!tips && tips !== ''" class="tips">{{tips}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    tips: String
  }
}
</script>

<style lang="scss" scoped>
.loading-container {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  @include transition(all .5s);
  .mask {
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .6);
  }
  .loader {
    position: absolute;
    @include center()
    text-align: center;
    .lds-rolling {
      position: relative;
      div {
        width: 80px;
        height: 80px;
        border: 4px solid nth($pink, 1);
        border-top-color: transparent;
        border-radius: 50%;
        -webkit-animation: lds-rolling 1s linear infinite;
        animation: lds-rolling 1s linear infinite;
        &:after {
          width: 80px;
          height: 80px;
          border: 4px solid nth($pink, 1);
          border-top-color: transparent;
          border-radius: 50%;
        }
      }
    }
  }
  .tips {
    margin-top: 10px;
    font-size: 1.2rem;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Loading.vue